import React from 'react';
import Modal from '@material-ui/core/Modal';
import Button from '@material-ui/core/Button';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Flatpickr from "react-flatpickr";
import Select2Wrapper from '../Select2Wrapper';

// MUI transitions
import Fade from '@material-ui/core/Fade';
import Backdrop from '@material-ui/core/Backdrop';
import { GENDERS_OPTIONS } from '../../constants/ProfileConstants';

export default class EhcEmployeeForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      employee: { ...props.employee },
      confirming: false
    };
  }

  baseUrl = (company_id) => `/api/ehc/companies/${company_id}/employees`;

  onConfirm = () => {
    this.setState({ confirming: true });
  };

  onCancel = () => {
    this.setState({ confirming: false });
  };

  onClose = () => {
    this.onCancel();
    this.props.onClose();
  };

  handleChange = (...args) => {
    let newEmployeeData = this.state.employee || {};
    for (let i = 0; (i + 1) < args.length; i += 2) {
      const field = args[i];
      const value = args[i + 1];
      newEmployeeData[field] = value;
    }
    this.setState({ employee: newEmployeeData });
  }

  handleEmployeeUpdate = async (event) => {
    event.preventDefault();

    const employee = this.state.employee;
    if (!this.props.editable || !employee) return;

    let formData = {
      full_name: employee.full_name,
      nik: employee.nik,
      email: employee.email,
      date_of_birth: employee.date_of_birth,
      mobile_phone: employee.mobile_phone,
      gender: employee.gender_value
    };

    const csrfToken = document.querySelector('[name=csrf-token]').content;
    const url = `${this.baseUrl(employee.company_id)}/${employee.id}`;

    try {
      const response = await fetch(url, {
        method: 'PUT',
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          'X-CSRF-Token': csrfToken
        },
        body: JSON.stringify(formData)
      });

      const result = await response.json();
      console.log('Employee update result:', result);

      if (response.ok) {
        this.onClose();
        if (this.props.tableRef.current) {
          this.props.tableRef.current.onQueryChange();
        }
      } else {
        console.error('Error updating employee:', result);
      }
    } catch (err) {
      console.error('Error updating employee:', err);
    }
  };

  // =====================
  // Render Component
  // =====================

  async componentDidUpdate(prevProps, prevState) {
    // If employee prop changes
    if (this.props.employee !== prevProps.employee) {
      this.setState({ employee: {...this.props.employee} });
    }
  }

  render() {
    return (
      <Modal
        open={this.props.open}
        onClose={this.onClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        style={{ overflow: 'auto' }}
      >
        <Fade in={this.props.open} timeout={500}>
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
            bgcolor="#fff"
            p={4}
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              outline: 'none',
              borderRadius: '4px',
              minWidth: '300px'
            }}
          >
            <form onSubmit={this.handleEmployeeUpdate}>
              <Typography variant="h6" gutterBottom>
                Employee Data
              </Typography>

              { this.state.employee &&
                <div className="row">
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="full_name">Name *</label>
                      <input
                        placeholder="Input full name"
                        disabled={!this.props.editable}
                        className="form-control"
                        required="required"
                        type="text"
                        value={this.state.employee.full_name || ''}
                        name="full_name"
                        onChange={(e) => this.handleChange("full_name", e.target.value)}
                      /><i className="form-group__bar"></i>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="nik">NIK *</label>
                      <input
                        placeholder="Input NIK"
                        disabled={!this.props.editable}
                        className="form-control"
                        required="required"
                        type="text" pattern="[0-9]{16}" maxLength={16}
                        title="NIK must be 16 digits"
                        value={this.state.employee.nik || ''}
                        name="nik"
                        onChange={(e) => this.handleChange("nik", e.target.value)}
                      /><i className="form-group__bar"></i>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="email">Email *</label>
                      <input
                        placeholder="Input email address"
                        disabled={!this.props.editable}
                        className="form-control"
                        required="required"
                        type="email"
                        value={this.state.employee.email || ''}
                        name="email"
                        onChange={(e) => this.handleChange("email", e.target.value)}
                      /><i className="form-group__bar"></i>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="date_of_birth">DOB *</label>
                      <Flatpickr
                        placeholder="YYYY-MM-DD"
                        disabled={!this.props.editable}
                        className="form-control"
                        required="required"
                        pattern="\d{4}-\d{2}-\d{2}"
                        title="Date must be in the format YYYY-MM-DD"
                        value={this.state.employee.date_of_birth || ''}
                        onClose={(selectedDates, dateStr, instance) => {
                          this.handleChange("date_of_birth", dateStr);
                        }}
                        options={{
                          dateFormat: "Y-m-d",
                          allowInput: true
                        }}
                      /><i className="form-group__bar"></i>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="mobile_phone">Phone *</label>
                      <input
                        placeholder="08XX XXXX XXXX"
                        disabled={!this.props.editable}
                        className="form-control"
                        required="required"
                        type="tel"
                        value={this.state.employee.mobile_phone || ''}
                        name="mobile_phone"
                        onChange={(e) => this.handleChange("mobile_phone", e.target.value)}
                      /><i className="form-group__bar"></i>
                    </div>
                  </div>
                  <div className="col-6">
                    <div className="form-group">
                      <label htmlFor="gender_value">Gender</label>
                      <Select2Wrapper
                        required
                        className="form-control"
                        value={this.state.employee.gender_value?.toString() || ''}
                        name="gender_value"
                        onChange={(e) => this.handleChange("gender_value", e.target.value)}
                        useDirectParent={true}
                        options={{
                          placeholder: "Select Gender",
                          disabled: !this.props.editable,
                        }}
                        items={GENDERS_OPTIONS}
                      >
                      </Select2Wrapper><i className="form-group__bar"></i>
                    </div>
                  </div>
                </div>
              }

              <Box className="d-flex justify-content-end">
                <Button
                  variant="outlined"
                  disabled={this.state.confirming}
                  onClick={this.onClose}
                  className="mr-2"
                >
                  Cancel
                </Button>
                {this.props.editable &&
                  <Button
                    variant="contained"
                    color="primary"
                    disabled={!this.state.employee || this.state.confirming}
                    className="mr-2"
                    onClick={this.onConfirm}
                  >
                    Update
                  </Button>
                }
              </Box>
              {this.props.editable && this.state.confirming &&
              <Box className="d-flex justify-content-end mt-4">
                <Button
                  variant="outlined"
                  onClick={this.onCancel}
                  className="mr-2"
                >
                  Cancel
                </Button>
                <Button
                  variant="contained"
                  style={{backgroundColor: "#366602ff", color: "#fff"}}
                  disabled={!this.state.employee}
                  className="mr-2"
                  type="submit"
                >
                  Confirm Update
                </Button>
              </Box>
              }
            </form>
          </Box>
        </Fade>
      </Modal>
    );
  }
}
